import React, { PureComponent } from 'react'
import Router, { withRouter } from 'next/router'

import { DOMAINS } from 'utils/Constants'
import { HomePageSEO } from 'components/SEO/HomePageSEO'
import BabySitterJobs from 'components/blogs/BabySitterJobs'
import CleaningLady from 'components/blogs/CleaningLady'
import CCAMainContainer from 'components/CCA/CCAMainContainer'
import CareGuideHomePage from 'components/CareGuideHomePage'
import MainContainer from 'components/MainContainer'
import AnalyticsPageViewTracker from '../utils/AnalyticsPageViewTracker'

const HomePageSwitch = ({ domain, pageProps, metaDescription, title, loggedIn }) => {
  const { BABY_SITTER_JOBS, CLEANING_LADY, CHILD_CARE_ADVANTAGE, CARE_GUIDE } = DOMAINS
  switch (domain) {
    case BABY_SITTER_JOBS:
      return <BabySitterJobs />
    case CARE_GUIDE:
      return <CareGuideHomePage pageProps={pageProps} />
    case CLEANING_LADY:
      return <CleaningLady />
    case CHILD_CARE_ADVANTAGE:
      return <CCAMainContainer {...pageProps} />
    default:
      return <MainContainer {...pageProps} />
  }
}

class Index extends PureComponent {
  analyticsPageViewTracker = new AnalyticsPageViewTracker('home')

  componentWillUnmount() {
    this.analyticsPageViewTracker.stopTracking()
  }

  componentDidMount() {
    const {
      router,
      pageProps: { domain },
    } = this.props
    this.analyticsPageViewTracker.startTracking(router, domain)
  }

  render() {
    const {
      pageProps: { domain },
      pageProps,
      metaDescription,
      title,
      loggedIn,
    } = this.props
    if (loggedIn) {
      Router.push('/homepage')
    }
    return (
      <>
        <HomePageSEO metaDescription={metaDescription} title={title} domain={domain} />
        <HomePageSwitch
          domain={domain}
          pageProps={pageProps}
          metaDescription={metaDescription}
          title={title}
        />
      </>
    )
  }
}
export default withRouter(Index)
